import { Grid } from "@mui/material";

const Nationality = (_props) => {
    const { candidateData, className } = _props
    return (
        <div className="print-web">
            <fieldset className={`${className}--fieldset`}>
                <legend className={`${className}--legend`}>
                    Nationality
                </legend>
                <Grid container spacing={1}>
                    <Grid item lg={3} md={3} sm={3} xs={6}>
                        <p className={`${className}--nationalityText`}>
                            Nationality
                        </p>
                    </Grid>
                    <Grid item lg={9} md={9} sm={9} xs={6}>
                        <p className={`${className}--nationalityText custom-rht2`}>
                            {candidateData?.nationality}
                        </p>
                    </Grid>
                </Grid>
            </fieldset>
        </div>
    )
}

export default Nationality;